import cx from 'classnames';

import Render from 'components/render';
import { LOCALES } from 'constants/dateTime';
import { CURRENCY_TYPE } from 'constants/enums';
import { formatFiat } from 'helpers/currency';
import {
  addZeroesUntilCorrectPrecision,
  convertFromUSDtoINR,
  cropAfterDecimals,
} from 'helpers/utils';
import subscribe from 'HOC/subscribe';
import useWalletIndianExchange from 'hooks/componentHooks/useWalletIndianExchange';
import i18n from 'i18n/config';
import { trackerAssetsHoldingsSelector } from 'selectors/holdingsSelectors';
import { openPositionMarkPriceSelectorById } from 'selectors/priceSelectors';
import { useAppSelector } from 'storeHooks';

import { getTotalTrackerEquity } from '../computeTotalBalance';
import styles from './indianWallet.module.scss';
import TooltipWrapper from './TooltipWrapper';

const trackerWalletLabel = i18n.t<string>('headerFooter:header.wallet.trackerWallet');

const TooltipBody = () => {
  return (
    (<div className={styles.tooltipBody} data-palette="TooltipBody">
      <span>Total value of tracker assets currently held</span>
    </div>)
  );
};

const SmartAssetEquity = subscribe(({ showAmount }: { showAmount: boolean }) => {
  const trackerHoldings = useAppSelector(trackerAssetsHoldingsSelector);
  const usdAssetMinPrecision = 2;

  const trackerEquity = getTotalTrackerEquity(
    trackerHoldings,
    openPositionMarkPriceSelectorById
  );

  const { inrConversionRate } = useWalletIndianExchange();

  const trackerEquityInInr = formatFiat(
    CURRENCY_TYPE.INR,
    cropAfterDecimals(
      addZeroesUntilCorrectPrecision(
        convertFromUSDtoINR(Number(trackerEquity), inrConversionRate),
        usdAssetMinPrecision
      ),
      usdAssetMinPrecision
    ),
    LOCALES.INDIA
  );

  const trackerEquityInUsd = formatFiat(
    CURRENCY_TYPE.USD,
    cropAfterDecimals(
      addZeroesUntilCorrectPrecision(Number(trackerEquity), usdAssetMinPrecision),
      usdAssetMinPrecision
    )
  );

  return (
    (<div
      className={cx(
        styles['label-value-container'],
        styles.accountValueCollapsableButton
      )}
      data-palette="SmartAssetEquity">
      <div className={styles.label}>
        <TooltipWrapper title={trackerWalletLabel} body={<TooltipBody />} />
      </div>
      <div className={cx('flex-set flex--column', styles.value)}>
        <span className={styles.inr}>
          <Render when={showAmount} else="******">
            {trackerEquityInInr}
          </Render>
        </span>
        <span className={styles.usd}>
          <Render when={showAmount} else="******">
            {trackerEquityInUsd}
          </Render>
        </span>
      </div>
    </div>)
  );
});

export default SmartAssetEquity;
